import React from 'react'

import { headed2SetupVars } from './headed2SetupVars'

export const californiaSetupVars = {
  siteId: 'california',
  pathPrefix: '/ca',
  topScreenshotUrl: '/images/california/marketing/Mockup@2x.png',
  menuHeader: "Discover California's Solution for:",
  appUrl: 'https://www.cacareerzone.org',
  appName: 'California CareerZone',
  freeEducatorAccountQuota: 50,
  logoImg: '/images/assets/california/horizontal/dark.svg',
  headerTitle: `The California CareerZone`,
  headerTitleDescription: (
    <div>
      <p>
        The California CareerZone is a state-supported career exploration and planning
        system designed to support career and college readiness, LCAPs and transition
        planning.
      </p>
      <h4>
        With a <b>FREE</b> Headed2 account, you will have access to:
      </h4>
      <ul className="top-features">
        <li className="onetprofile">Occupation & College Info</li>
        <li className="financial-literacy">Financial Literacy Tools</li>
        <li className="onetassess">Self Assessments</li>
        <li className="plantool">Planning Tools</li>
      </ul>
    </div>
  ),
  sponsorMsg: (
    <span>
      Trusted by the <b>California Career Resource Network</b> and the{' '}
      <b>California Department of Education</b> to help <b>increase career readiness</b>{' '}
      for students in California.
    </span>
  ),
  sponsorImg: '/images/california/marketing/DepartmentOfEducationSponsored@2x.png',
  brochureDownloadImg: '/images/www/new/homepage/Homepage-Download-CCZ@2x.png',
  brochureDownloadUrl: `https://drive.google.com/uc?export=download&id=13XaX9jOLCplibslfnU2D0JfrGkeCMgl0`,
  //webinarUrl: "https://h2-training.s3.amazonaws.com/California+CareerZone+New+Free+and+Upgrade+Features+for+2019+Webinar.mp4",
  webinar: {
    upcoming: {
      webinarSignupForm: 'e9b3b105-0728-4b56-9634-37da30faeb37',
      webinarDetails:
        'Have you wondered if the CareerZone Upgrade would make sense for your school or district? In this webinar we will review some of the key features of the CareerZone upgrade as well as possible funding sources.'
    }
  },
  webinarHistory: [
    {
      date: 'January 2021',
      sortableDate: new Date('1/1/2021'),
      title: 'California CareerZone  - Educating for Careers',
      description: "Learn what's new with the California CareerZone",
      videoUrl:
        'https://h2-training.s3.amazonaws.com/California+CareerZone++-+Educating+for+Careers.mp4'
    },
    ...headed2SetupVars.webinarHistory
  ],
  otherSites: [
    {
      url: 'https://www.pacareerzone.org',
      logoSrc: '/images/arkansas/marketing/Images/Export/PA-logo.svg'
    },
    {
      url: 'https://ar.headed2.com',
      logoSrc: '/images/arkansas/marketing/Images/Export/AR-Logo.svg'
    },
    {
      url: 'https://nv.headed2.com',
      logoSrc: '/images/arkansas/marketing/Images/Export/NV-logo.svg'
    },
    {
      url: 'https://va.headed2.com',
      logoSrc: '/images/arkansas/marketing/Images/Export/VA-logo.svg'
    }
  ]
}
